export default __webpack_public_path__ + "static/media/mobile-roadmap.c7605da5.png";